import {
  Facebook,
  LinkedIn,
} from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Typography,
  Divider,
} from "@mui/material";
import React from "react";
import { HashLink } from "react-router-hash-link";
import AppLinks from "./AppLinks";

const footerMenu = [
  {
    title: "Product",
    links: [
      { to: "/#Why_Choose", label: "Why Choose Us" },
      { to: "/#Reviews", label: "Reviews" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about#what_we_offer", label: "What We Offer" },
      { to: "/about#faq", label: "FAQ" },
      { to: "/contact#contact_us", label: "Contact Us" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms & Conditions" },
      { to: "/contact#contact_us", label: "Support" },
    ],
  },
];

const SocialButton = ({ Icon, url }) => (
  <IconButton
    component="a"
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      color: "#94a3b8",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.08)",
        color: "#ffffff",
        transform: "translateY(-3px)",
      },
    }}
  >
    <Icon />
  </IconButton>
);

const Footer = () => {
  return (
    <Box
      sx={{
        mt: 10,
        pt: 6,
        pb: 6,
        background: "linear-gradient(180deg, rgba(15,23,42,0.95) 0%, #0f172a 100%)",
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        color: "#cbd5e1",
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={8}>
          {/* BRAND COLUMN */}
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
              <img
                src="/logoWhite.png"
                alt="MySchoolling"
                height={42}
              />
              <Typography
                variant="h5"
                fontWeight={700}
                color="white"
              >
                MySchoolling
              </Typography>
            </Box>

            <Typography
              variant="body1"
              sx={{ mb: 4, maxWidth: 340, lineHeight: 1.7 }}
            >
              Empowering schools and parents with intelligent learning
              tools, real-time insights, and seamless digital management.
            </Typography>

            <Box display="flex" gap={1}>
              <SocialButton
                Icon={XIcon}
                url="https://x.com/MSchoollin95170"
              />
              <SocialButton
                Icon={Facebook}
                url="https://www.facebook.com/profile.php?id=61576745007909"
              />
              <SocialButton
                Icon={LinkedIn}
                url="https://myschoolling.com"
              />
            </Box>

            <Box mt={4}>
              <AppLinks />
            </Box>
          </Grid>

          {/* MENU COLUMNS */}
          {footerMenu.map((section) => (
            <Grid item xs={6} md={2.5} key={section.title}>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                color="white"
                gutterBottom
              >
                {section.title}
              </Typography>

              {section.links.map((link) => (
                <HashLink
                  key={link.label}
                  smooth
                  to={link.to}
                  style={{
                    display: "block",
                    marginBottom: 14,
                    color: "#94a3b8",
                    textDecoration: "none",
                    position: "relative",
                    transition: "color 0.3s ease",
                  }}
                >
                  {link.label}
                </HashLink>
              ))}
            </Grid>
          ))}
        </Grid>

        <Divider
          sx={{
            my: 6,
            borderColor: "rgba(255,255,255,0.08)",
          }}
        />

        {/* BOTTOM BAR */}
        <Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  flexDirection={{ xs: "column", md: "row" }}
  gap={2}
>
  <Typography
    variant="body2"
    color="#94a3b8"
    fontWeight={500}
    textAlign={{ xs: "center", md: "left" }}
  >
    © {new Date().getFullYear()}{" "}
    <span style={{ fontWeight: 600 }}>
      MySchoolling
      <sup style={{ fontSize: "0.6em", verticalAlign: "super" }}>™</sup>
    </span>{" "}
    – A product of Versynix Global Pvt. Ltd. All rights reserved.
  </Typography>

  <Typography
    variant="body2"
    color="#94a3b8"
    fontWeight={500}
    textAlign={{ xs: "center", md: "right" }}
  >
    Built for Modern Education.
  </Typography>
</Box>
      </Container>
    </Box>
  );
};

export default Footer;